/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OverviewAutoResourceDetail } from './overviewAutoResourceDetail';


export interface OverviewAutoResource { 
    amount: string;
    information: string;
    description: string;
    detail: OverviewAutoResourceDetail;
}

